var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FDC469"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4615 12.4797V29.2308C21.992 29.0851 23.3459 29.0619 24.6435 28.3566L28.1632 26.4436C29.271 25.8415 29.6922 24.8045 29.6922 23.8009V14.0271C29.6922 11.4614 25.8812 9.85825 23.0489 11.3977C22.2241 11.8459 21.4277 12.3493 20.4615 12.4797Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5384 29.2308C18.0065 29.0851 16.8906 29.0619 15.5918 28.3566L12.069 26.4435C10.9602 25.8414 10.3076 24.8964 10.3076 23.8929V13.8884C10.3076 11.3227 14.353 9.85817 17.1879 11.3976C18.0133 11.8458 18.5713 12.3493 19.5384 12.4797V29.2308Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5386 12.4892H20.4617V29.2308H19.5386V12.4892Z",
    fill: "#C3D3E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskBook);
export default __webpack_public_path__ + "static/media/task-book.416f14215bffb3a9403a34be855ee8d0.svg";
export { ForwardRef as ReactComponent };